import { useQuery } from '@tanstack/react-query';
import { CenterSpinner } from '@/Domain/components/Shared/CenterSpinner/CenterSpinner';
import {
  AISettings,
  ConversationStylePage,
} from '@/UI/Identity/ConversationStyle/ConversationStyle.page';

export const ConversationStyleLoader = () => {
  const { data, isLoading } = useQuery<AISettings>({ queryKey: ['settings'] });

  if (isLoading) {
    return <CenterSpinner />;
  }

  return <ConversationStylePage data={data!} />;
};
